import store from "../store/";
import StoreConstants from "../store/services/StoreConstants";

export default {
  navGuardLoggedIn(next) {
    let session = store.getters[StoreConstants.GETTERS.IS_LOGGED_IN];
    if (!session) {
      store.dispatch(StoreConstants.ACTIONS.SIGN_OUT).then(() => {
        next({ name: "Login" });
      });
    } else {
      next();
    }
  },

  navGuardAdmin(next) {
    let isAdmin = store.getters[StoreConstants.GETTERS.IS_ADMIN];
    if (!isAdmin) {
      store.dispatch(StoreConstants.ACTIONS.SIGN_OUT).then(() => {
        next({ name: "Login" });
      });
    } else {
      next();
    }
  }
};
